
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 646 452.23"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"a","transform":"translate(0 27.53)"}},[_c('ellipse',{attrs:{"cx":"323","cy":"198.87","rx":"323","ry":"198.87","fill":"none"}})])]),_c('g',{attrs:{"data-name":"Layer 2"}},[_c('g',{attrs:{"data-name":"Layer 1","clip-path":"url(#a)"}},[_c('ellipse',{attrs:{"cx":"323","cy":"226.39","rx":"323","ry":"198.87","fill":"#efefef"}}),_c('circle',{attrs:{"cx":"323","cy":"226.11","r":"226.11","fill":"#cdd508"}}),_c('g',{staticClass:"pupil"},[_c('circle',{attrs:{"cx":"323","cy":"226.11","r":"103.24","fill":"#00973f"}}),_c('circle',{attrs:{"cx":"369.17","cy":"184.99","r":"41.37","fill":"#d2d4d4","opacity":".47"}})])])])])
          )
        }
      }
    